import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
//import propertytypesApi from "../../api/propertytype";
import IntlMessages from '../../components/IntlMessage';
import {
  Button,
  Card,
  Table,
  Modal,
  Switch,
  Row,
  Col,
  Space,
  Image,
} from 'antd';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import PageTitle from '../../components/PageTitle';
import { debounce } from 'lodash';
import { useIntl } from 'react-intl';
import ActionBar from '../../components/ActionBar';
import paymentMethodApi from '../../api/paymentMethod';
import FilterBar from '../../components/FilterBar';
import PaymentMethodForm from './PaymentMethodForm';

PaymentMethods.propTypes = {
  items: PropTypes.array,
};
PaymentMethods.defaultProps = {
  items: [],
};

function PaymentMethods(props) {
  // const isMount = useRef(false)

  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(1);
  const [item, setItem] = useState(null);
  const [deleting, setDeleting] = useState(false);
  const [loading, setLoading] = useState(true);
  const [reload, setReload] = useState(true);
  const [condition, setCondition] = useState({});

  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
    keyword: '',
    order_by: 'title',
    order_dir: 'ASC',
  });
  const [modal, setModal] = useState(false);

  const onChangeTable = async (
    pagination,
    filters,
    sorter,
    extra = { currentDataSource: [] }
  ) => {
    setFilter({
      ...filter,
      page: pagination.current,
      limit: pagination.pageSize,
      order_dir: getOrder(sorter.order),
      order_by: sorter.columnKey ? `${sorter.columnKey}` : 'title',
    });
  };

  const onFilter = debounce(async (value, title, type) => {
    if (type === 'search') {
      setFilter((filter) => {
        return { ...filter, keyword: value, page: 1 };
      });
    } else {
      const filter_obj = { ...condition, [title]: value };
      let filter_name = [];
      let filter_value = [];
      for (var key in filter_obj) {
        if (filter_obj[key]) {
          filter_name.push(key);
          filter_value.push(filter_obj[key]);
        }
      }
      setFilter((filter) => {
        return {
          ...filter,
          filter_name: filter_name,
          filter_value: filter_value,
          page: 1,
        };
      });
    }
  }, 300);

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      let items = await paymentMethodApi.getAll(filter);

      setItems(items.data);
      setLoading(false);
      setDeleting(false);
      setTotal(items.total);
    }
    fetchData();
  }, [filter, deleting, reload]);

  const onReload = () => {
    setReload((reload) => !reload);
  };

  const onOpenModal = (record = null) => {
    setModal(true);
    setItem(record);
    // console.log(record);
  };

  const onCloseModal = () => {
    setModal(false);
  };
  const intl = useIntl();
  const onRemove = (data) => {
    Modal.confirm({
      title: intl.formatMessage({ id: 'global.delete_confirm' }),
      okText: intl.formatMessage({ id: 'global.yes' }),
      onOk: async () => {
        await paymentMethodApi.delete(data.id).catch((error) => {
          console.error(error);
          Modal.error({
            title: error.data.message,
            okText: intl.formatMessage({ id: 'global.close' }),
          });
          setLoading(false);
        });
        setDeleting(true);
      },
      onCancel() {},
    });
  };
  const onChangeStatus = async (ischecked, record) => {
    await paymentMethodApi.update(record.id, { status: ischecked });

    setItems((items) =>
      items.map((data) => {
        if (data.id === record.id)
          return {
            ...data,
            status: ischecked,
          };
        return data;
      })
    );
  };

  const getOrder = (order) => {
    if (order === 'ascend') return 'ASC';
    if (order === 'descend') return 'DESC';
    return 'ASC';
  };

  const columns = [
    {
      title: <IntlMessages id="global.id" />,
      key: 'id',
      width: 20,
      sorter: true,
      dataIndex: 'id',
      render: (text, record, index) => {
        return index + 1;
      },
    },
    {
      title: <IntlMessages id="global.cover_image" />,
      key: 'image',
      dataIndex: 'image',
      render: (text, record) => {
        return record.image ? <Image width={50} src={record.image} /> : '';
      },
    },
    {
      title: <IntlMessages id="global.title" />,
      key: 'title',
      sorter: true,

      dataIndex: 'title',
      render: (text, record) => {
        return (
          <Button
            type="primary"
            size="small"
            onClick={() => onOpenModal(record)}
            shape="round"
            icon={<EditOutlined />}
          >
            {record.title}
          </Button>
        );
      },
    },

    {
      title: <IntlMessages id="global.code" />,
      key: 'code',
      sorter: true,

      dataIndex: 'code',
      render: (text, record) => {
        return record.code;
      },
    },

    {
      title: <IntlMessages id="global.merchant_id" />,
      key: 'merchant_id',

      dataIndex: 'merchant_id',
      render: (text, record) => {
        return record.merchant_id;
      },
    },

    {
      title: <IntlMessages id="global.secret_key" />,
      key: 'secret_key',

      dataIndex: 'secret_key',
      render: (text, record) => {
        return record.secret_key;
      },
    },

    {
      title: <IntlMessages id="global.status" />,
      key: 'status',

      dataIndex: 'status',
      render: (text, record) => {
        return (
          <Switch
            checked={record.status}
            onChange={(checked) => onChangeStatus(checked, record)}
          />
        );
      },
    },

    {
      title: '',
      align: true,
      render: (text, record) => {
        return (
          <Space>
            <Button
              type="primary"
              size="small"
              onClick={() => onRemove(record)}
              danger
              shape="round"
              icon={<DeleteOutlined />}
            ></Button>
          </Space>
        );
      },
    },
  ];

  return (
    <Card bordered={false} style={{ minHeight: '100%' }}>
      <Row justify="space-between">
        <Col>
          {' '}
          <PageTitle title={<IntlMessages id="global.payment_method" />} />
        </Col>

        <Col>
          <ActionBar
            onRefresh={() => onReload()}
            isShowAddButton={true}
            onAdd={onOpenModal}
            isShowPublishButtons={false}
            isShowCopyButton={false}
            isShowDeleteButton={false}
          ></ActionBar>
        </Col>
      </Row>

      <FilterBar onFilter={onFilter} data={[]}></FilterBar>

      <Table
        tableLayout="auto"
        columns={columns}
        dataSource={items}
        onChange={onChangeTable}
        rowKey="id"
        size="small"
        loading={loading}
        scroll={{
          x: 'max-content',
        }}
        pagination={{
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '50'],
          total: total,
          current: filter.page,
          pageSize: filter.limit,
        }}
      />
      {modal ? (
        <PaymentMethodForm
          open={modal}
          onClose={onCloseModal}
          currentData={item}
          onReload={onReload}
        />
      ) : null}
    </Card>
  );
}

export default PaymentMethods;
